var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrokeOnDarkBlueVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7149 10.573C17.032 10.7682 17.032 11.2292 16.7149 11.4244L12.3091 14.1378C11.9759 14.3429 11.5469 14.1032 11.5469 13.712V8.28539C11.5469 7.89415 11.9759 7.65449 12.3091 7.85965L16.7149 10.573Z",
    fill: "#00B0F0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 25,
    height: 20,
    rx: 3,
    stroke: "#00B0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrokeOnDarkBlueVideo);
export default __webpack_public_path__ + "static/media/stroke-on-dark-blue-video.3f5ab58b6749d0c2786125830773d8d3.svg";
export { ForwardRef as ReactComponent };